import { render } from "./navigationFrench.vue?vue&type=template&id=15da32e1&lang=true"
import script from "./navigationFrench.vue?vue&type=script&lang=js"
export * from "./navigationFrench.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__